export default "__VITE_ASSET__BUde6bM9__"